import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import SarfTwreed from "./SarfTwreed";
const defaultAutos = {
  Safes: [],
};

export default function SarfSafesCon() {


  const tb = {
    wait: true,
    Safe: true,
    SafeEmp: true,
    Branch: true,
    costcenters: true,
    other: true,
    Units: true,
    EmpItems: true,
    // Groups:true,
    Users: true,
    MedAccounts: true,
    AllAccountsIndex: true,
    omlats: true,
    // stor: sto,
    PermissionsElemnts:true,
    stor: { ...sto, branchi: sto.branchi },

    parms: {
      safe: -1,
      tname: "sarf",
      medname: "sarf",
      iempid: sto.empi,
      branch: sto.branchi,
      iformid: 70008,
      db_name:sto?.db_name
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <SarfTwreed
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
        IsSarf: true,
      }}
    />
  );
}
